export enum ContentLayout8Theme {
  CREAM = 'CREAM',
  BLUE = 'BLUE',
  RED = 'RED',
  OPAL = 'OPAL',
}
